import React from 'react';
import { Text } from '../../../../../atoms/Text/Text';
import './ChainStepBadgeStyles.scss';
const baseClass = 'qmb-ui-chain-step-badge';
export function ChainStepBadge({ step, total }) {
    return (React.createElement(Text, { variant: "xx-small", className: baseClass, "aria-label": `Step ${step} of ${total}` },
        "Step ",
        step,
        " of ",
        total));
}
